export const DOMAIN_UPDATE_STATE = "DOMAIN_UPDATE_STATE"
